import { render } from "./product-form.vue?vue&type=template&id=2783b0b4"
import script from "./product-form.vue?vue&type=script&lang=js"
export * from "./product-form.vue?vue&type=script&lang=js"

import "./product-form.vue?vue&type=style&index=0&id=2783b0b4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__